import React from "react";
import './Delivery.css'
import BuscarClienteDelivery from "./DeliveryCliente";
import { formatSoles } from "../../Global";


class DeliveryAgregarIzquierda extends React.Component{
    constructor(props){
        super(props);
        this.state ={
        }
    }



    render(){
        const { 
            productos, 
            Documento, 
            dataCliente, 
            buscar, 
            handleClickNuevo, 
            handleChange, 
            handleEnterKeyUp,
            TraerClientePorDoc,
        } = this.props;

        return(
            <div className="encabezado col-12 col-sm-6 no-pad h-100">
                <BuscarClienteDelivery 
                    Documento={Documento}
                    handleClickNuevo={handleClickNuevo}
                    dataCliente={dataCliente}
                    TraerClientePorDoc={TraerClientePorDoc}
                />
                <div className="PreVBuscarProducto">
                    <div className="w-100 col-12 mt-1">
                        <input
                            type="text"
                            id="InputBuscarProd"
                            placeholder="Buscar Producto"
                            className="mr-2 w-100 DocProductoPreventa borde-15 mb-1"
                            onKeyUp={handleEnterKeyUp}
                            value={buscar}
                            onChange={handleChange}
                            autoFocus
                        />
                    </div>
                </div>
                <div className="form-group encabezadoPV">
                    <div className="preventa__tipo--comprobante">
                        <div id="tableProdPreventa" className="lista_productos table-responsive">
                            <div className="lista_productos__item">
                                <table className="table table-hover">
                                    <thead>
                                        <tr>
                                            <th style={{borderTopLeftRadius: "10px", backgroundColor: "#034b2f", color:"white"}}>
                                                <span>Producto / </span><span>Presentación</span>
                                            </th>
                                            <th style={{backgroundColor: "#034b2f",borderTopRightRadius: "10px",textAlign:"center", color:"white"}}>Precio</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {productos.map((p) => (
                                            <tr 
                                                key={p.id}
                                                className="prodPreventaTr"
                                                style={{cursor: "pointer"}}
                                                title={`${p.nombre} - ${p.presentacion}`}
                                            >
                                                <td>
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <label>{p.nombre} {p.presentacion}</label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div style={{textAlign: "center"}}>
                                                        S/ {formatSoles(p.precio)}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default DeliveryAgregarIzquierda;